import React, { useEffect, useState, useRef } from "react";
import ChatMessageInput from "../component/ChatMessageInput";
import { authAxios } from "../config/config";
import IsLoadingHOC from "../common/IsLoadingHOC";
import { toast } from "react-toastify";
import ReactMarkdown from "react-markdown";
import { useLocation } from "react-router-dom";
import { ModifyText } from "../helper/helper";
import { useSelector } from "react-redux";

const StoryPage = (props) => {
  const { setLoading } = props;
  const location = useLocation();
  const ids = location?.state?.id;

  const [formdata, setformdata] = useState({
    category: "Story",
    title: "Story Title",
    query: "",
    response: "",
  });

  const userName = useSelector((state) => state.auth.user.fname);
  const [allData, setallData] = useState([]);
  const [storyData, setstoryData] = useState([]);
  const [intro, setIntro] = useState(true);
  const [interaction, setinteraction] = useState("");
  const [Chat, setChat] = useState([]);
  const chatContainerRef = useRef(null);

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      setIntro(false);
      handleAnswer();
    }
  };

  const handleFectchStoryId = async (id) => {
    setLoading(true);
    await authAxios()
      .get(`/stories/get-single-story/${id}`)
      .then((response) => {
        setLoading(false);
        setIntro(false);
        setallData([]);
        const resData = response?.data;
        setstoryData(resData?.data);
        sessionStorage.removeItem("question", "");
      })
      .catch((error) => {
        setLoading(false);
        setallData([]);
        toast.error();
      });
  };

  const dummyDisplayquestion = sessionStorage.getItem("question");
  const storyId = sessionStorage.getItem("story_id");

  useEffect(() => {
    if (ids) {
      handleFectchStoryId(ids);
    } else if (storyId) {
      handleFectchStoryId(storyId);
    }
  }, [ids]);

  const StartInteraction = async () => {
    setLoading(true);
    await authAxios()
      .get(`/stories/start-interaction`)
      .then((response) => {
        setLoading(false);
        const resData = response?.data;
        console.log(resData.data.question, "sdfsdjfsodjf");

        setformdata((prev) => {
          const updatedFormData = {
            ...prev,
            response: resData.data.question || resData?.data?.story,
          };

          if (storyId) {
            handleSendMessage(updatedFormData);
          } else {
            createstory(updatedFormData);
          }

          return updatedFormData;
        });
        setinteraction(resData.data.question);
        setChat((prevChat) => [
          ...prevChat,
          { type: "question", text: resData.data.question },
        ]);
      })
      .catch((error) => {
        setLoading(false);
        toast.error();
      });
  };

  useEffect(() => {
    if (sessionStorage.getItem("story_id")) {
      return;
    }
      StartInteraction();
  }, []);

  const handleSendMessage = async (updatedFormData) => {
    const storyId = sessionStorage.getItem("story_id");

    const payLoad = {
      isNewQuery: updatedFormData.query,
      response: updatedFormData.response,
    };
    setLoading(true);
    await authAxios()
      .post(`/stories/conversation/${storyId || ids}`, payLoad)
      .then(async (response) => {
        const resData = response.data;

        setLoading(false);
        setIntro(false);

        if (resData.status === 1) {
          console.log(resData.data);

          handleFectchStoryId(storyId || ids);

          setformdata((prev) => ({
            ...prev,
            query: "",
          }));
        } else {
          toast.error(resData.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response.data.message);
      });
  };

  const handleAnswer = async () => {
    if(allData.length === 0 && storyData.length===0){
      return
    }
    setLoading(true);
    await authAxios()
      .post(`/stories/handle-answer`, { answer: formdata.query })
      .then(async (response) => {
        setLoading(false);
        const resData = response?.data;
        setformdata((prev) => {
          const updatedFormData = {
            ...prev,
            response: resData.data.question || resData?.data?.story,
          };

          if (storyId) {
            handleSendMessage(updatedFormData);
          }
          return updatedFormData;
        });

        const newChatEntries = [
          ...Chat,
          { type: "answer", text: formdata.query },
          {
            type: "question",
            text: resData.data.question || resData?.data?.story,
          },
        ];

        if (resData.data.review_prompt) {
          newChatEntries.push({
            type: "question",
            text: resData.data.review_prompt,
          });
        }

        setChat(newChatEntries);
      })
      .catch((error) => {
        setLoading(false);
        toast.error();
      });
  };

  const createstory = async (updatedFormData) => {
    const payLoad = {
      category: updatedFormData.category,
      title: updatedFormData.title,
      query: "hii",
      response: updatedFormData.response,
    };

    await authAxios()
      .post(`/stories/create-stories`, payLoad)
      .then(async (response) => {
        const resData = response.data;

        setLoading(false);
        console.log("res", resData);
        if (resData.status === 1) {
          // toast.success(resData.message);

          sessionStorage.setItem("story_id", resData.data.story_id);
         

          setallData([
            ...allData,
            { query: resData.data.query, response: resData.data.response },
          ]);

          setformdata((prev) => ({
            ...prev,
            query: "",
          }));
        } else {
          toast.error(resData.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response.data.message);
      });
  };

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [Chat, storyData]);

  return (
    <>
      <div className="h-full flex flex-col justify-between">
        <div>
          <style>
            {`
              .custom-scrollbar::-webkit-scrollbar {
                width: 10px;
              }
              .custom-scrollbar::-webkit-scrollbar-thumb {
                background: #fce7da;
                border-radius: 10px;
              }
            `}
          </style>
          <div
            ref={chatContainerRef}
            className={`py-[20px] overflow-auto h-[calc(100vh-230px)] pb-[35px] custom-scrollbar`}
          >
            <div className="bg-[#FFE6D9] border-[2px] border-[#EE635B] p-[15px] rounded-[10px] flex items-center gap-5 max-w-[885px] w-full mx-auto mb-5">
              <div>
                <img
                  src="./assets/images/story-c.png"
                  alt="image"
                  className="w-[65px] aspect-square"
                />
              </div>
              <p className="text-[#2C2C2C] text-[20px] font-semibold">
                Write your story
              </p>
            </div>
            <div
              className="max-w-[885px] w-full mx-auto flex flex-col gap-[30px]"
              style={{ "padding-bottom": "0px" }}
            >
                 <div className="bg-[#FFE6D9] rounded-[5px] p-[20px] max-w-[685px] w-full mr-auto">
                <p>Welcome to WeBC Story Generator! Effortlessly create compelling and inspiring stories with our intuitive story generator!</p>
                </div>
                {(allData && allData.length > 0 ? allData : storyData).map(
                  (item, index) => (
                    <React.Fragment key={index}>
                      {index !== 0 && (
                        <div className="bg-[#F1F1F1] rounded-[5px] p-[20px] max-w-[685px] w-full ml-auto">
                          <ReactMarkdown>{item.query}</ReactMarkdown>
                        </div>
                      )}
                      <div className="bg-[#FFE6D9] rounded-[5px] p-[20px] max-w-[685px] w-full mr-auto">
                        <p
                          dangerouslySetInnerHTML={{
                            __html: ModifyText(item.response),
                          }}
                        />
                      </div>
                    </React.Fragment>
                  )
                )}
              
            </div>
          </div>
          <ChatMessageInput
            backgroundColor={"#FFE6D9"}
            handleAnswer={handleAnswer}
            handleKeyDown={handleKeyDown}
            formdata={formdata}
            setformdata={setformdata}
          />
        </div>
        <div className="absolute bottom-[-40px] w-[100%] left-[50%] translate-x-[-50%] pb-5 pt-3">
          <p
            className="max-w-[885px] w-[95%] min-h-[65px] p-[11px] rounded-[10px] flex i mx-auto"
            style={{ fontSize: "11px" }}
          >
            <strong>Note:&nbsp;</strong> Providing detailed information makes
            your story more personalized and impactful; please ensure the
            accuracy of your details to avoid any false information.
          </p>
        </div>
      </div>
    </>
  );
};

export default IsLoadingHOC(StoryPage);